<idt-common-styles-render
  [styles]="piece!.settings.styles">
  <render-slice
    class="slice-fragment"
    *ngFor="let slice of children; trackBy: trackByIndex"
    [slice]="slice">
  </render-slice>
</idt-common-styles-render>
